"use client";

import { useState } from "react";

const useClipboard = () => {
	const [isCopied, setIsCopied] = useState<boolean>(false);

	const handleCopy = async (textToCopy: string) => {
		try {
			await navigator.clipboard.writeText(textToCopy);
			setIsCopied(true);

			setTimeout(() => {
				setIsCopied(false);
			}, 3000);
		} catch (error) {
			console.error("Error copying to clipboard:", error);
		}
	};

	return { isCopied, handleCopy };
};

export default useClipboard;
